import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import * as R from "ramda";
import { Field } from "react-final-form";
import { dicasApi as api } from "../../services/Api";
import { loopback, RichText, ListApi, FormApi, List, CrudForm } from "elentari";
import ImagePicker from "../../components/ImagePicker";

const { loopbackFilters } = loopback;

const DicasFilter = () => (
  <Grid spacing={24} container>
    <Grid item xs>
      <Field fullWidth label="Titulo" component={TextField} name="titulo" />
    </Grid>
  </Grid>
);

export function DicasList(props) {
  const listOptions = {
    defaultOrder: "id",
    fields: {
      id: {
        label: "Id",
      },
      titulo: {
        label: "Titulo",
      },
      texto: {
        label: "Descrição",
      },
    },
  };

  return (
    <ListApi
      filtersConfig={{
        titulo: loopbackFilters.regexp,
      }}
      api={api}
    >
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          filter={DicasFilter}
          filterLabels={{ find: "Buscar", clear: "Limpar" }}
          labelNew="Novo"
          onClickEdit={(item) => props.history.push(`/dicas/${item.id}`)}
          onClickNew={() => props.history.push("/dicas/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function DicasForm(props) {
  const validate = (values) => ({
    titulo: values.titulo ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        imagemUrl: Array.isArray(data.imagemUrl) ? undefined : data.imagemUrl,
      },
    });

    if (Array.isArray(data.imagemUrl)) {
      const formData = new FormData();
      formData.append("image", data.imagemUrl[0].file);
      await api.uploadImagem(R.path(["data", "id"], result) || id, formData);
    }

    return result;
  };

  return (
    <FormApi api={api} submitDecorator={submitDecorator} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item>
              <Field
                defaultImage={require("../../images/empty-image.png")}
                width={150}
                height={150}
                component={(props) => <ImagePicker {...props} />}
                name="imagemUrl"
              />
            </Grid>
            <Grid item xs>
              <Field
                fullWidth
                autoFocus
                component={TextField}
                label="Título"
                name="titulo"
              />
            </Grid>
            <Grid item xs={12}>
              <Field component={RichText} name="texto" label="Texto" />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
